import React from "react";
import {Col, Row, Spinner} from "react-bootstrap";
import {Route, Routes} from "react-router-dom";
import FindYourCaddie from "../../postRound/pages/FindYourCaddie";
import {
    FIND_YOUR_CADDIE,
    PAY_CADDIE,
    PAYMENT_CONFIRMATION,
    REVIEW_CADDIE,
    REVIEW_CONFIRMED
} from "../../../services/PageUtils";
import ReviewCaddie from "../../postRound/pages/ReviewCaddie";
import ReviewConfirmed from "../../postRound/pages/ReviewConfirmed";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {SessionState} from "../../../services/store/reducers/session/slice";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import PayCaddie from "../../postRound/pages/PayCaddie";
import CompletedPaymentStatus from "../../postRound/pages/CompletedPaymentStatus";

interface Props {
    logOut: () => void
}

const PlatformApp = ({logOut}: Props) => {

    const { sessionState } = handicaddieSelector(state => state.session)
    const { clubIdFromUrl, selectedClub } = handicaddieSelector(state => state.clubs)

    if (!clubIdFromUrl || !selectedClub) {
         return (<div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '3em',
            textAlign: 'center'
        }}>
            <Row>
                <Col>
                    <HandicaddieLogo size={'lg'} />
                    <h5 style={{ marginTop: '32px' }}>Unable to detect your club, please scan the QR code again.</h5>
                </Col>
            </Row>
        </div>)
    }

    return (
        <>
            {(sessionState !== SessionState.ACTIVE) &&
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '3em',
                    textAlign: 'center'
                }}>
                    <Row>
                        <Col>
                            <Spinner animation="border" variant="primary" />
                            <h5>Loading...</h5>
                        </Col>
                    </Row>
                </div>
            }

            {(sessionState === SessionState.ACTIVE) && <Routes>
                <Route path={FIND_YOUR_CADDIE} element={<FindYourCaddie/>}/>
                <Route path={PAY_CADDIE} element={<PayCaddie/>}/>
                <Route path={PAYMENT_CONFIRMATION} element={<CompletedPaymentStatus/>}/>
                <Route path={REVIEW_CADDIE} element={<ReviewCaddie/>}/>
                <Route path={REVIEW_CONFIRMED} element={<ReviewConfirmed/>}/>
                <Route index element={<FindYourCaddie/>}/>
            </Routes>}
        </>
    )

}

export default PlatformApp;